import { InputLabel } from './InputLabel';

interface IViewModeFiend {
  className?: string;
  title: string;
  value: any;
}

/**
 * @deprecated When using new form and input components
 * from `@sr/ui-library`, just set the input prop to `disabled`.
 */
const ViewModeField = ({ className, title, value }: IViewModeFiend) => {
  return (
    <div className={className}>
      <InputLabel label={title} inputId={title} />

      <div className="mt-3 break-all pl-1 font-sans font-normal leading-normal text-sr-text-secondary">
        {value}
      </div>
    </div>
  );
};

export default ViewModeField;
